import React, { useEffect, useState } from 'react'
import { DatePicker, Divider, Drawer, Form, Input, Spin } from 'antd'
import { t } from 'i18next'
import { useForm } from 'antd/es/form/Form'
import { post } from '../../Common/api'
import { stripHtml } from '../../Common/Common'
import EventComments from './EventComments'
import EventDescription from './EventDescription'
import CustModal from '../../Common/CustModal'

const { TextArea } = Input

export default function EventPanel ({ event, onClose, open, updateEventRequest, updateEvent, setSelectedEvent, addComment }) {
  const [form] = useForm()
  const [level2Form] = useForm()
  const [comments, setComments] = useState([])
  const [content, setContent] = useState('')
  const [saveInProgress, setSaveInProgress] = useState(false)
  const [loading, setLoading] = useState(false)
  const [displayLevel2Form, setDisplayLevel2Form] = useState(false)

  useEffect(() => {
    setComments(event?.comments || [])
    form.setFieldsValue(event)
    if (event?.id) {
      window.history.replaceState(null, 'Event Detail', `/admin/events/${event.id}`)
    }
  }, [event])

  useEffect(() => {
    if (saveInProgress) {
      setSaveInProgress(false)
      event.content = content
      updateEventRequest(event)
    }
  }, [saveInProgress])

  const updateTitle = (newTitle) => {
    if (newTitle.target.value !== event.title) {
      event.title = newTitle.target.value
      updateEventRequest(event)
    }
  }

  const saveContent = () => {
    setSaveInProgress(true)
  }

  const onClick = () => {
    level2Form.resetFields()
    setDisplayLevel2Form(true)
  }

  const saveLevel2 = (event) => {
    setLoading(true)
    post({
      url: `admin/events/${event.id}/level2_ticket`,
      params: level2Form.getFieldsValue(),
      onSuccess: (res) => {
        setSelectedEvent(res)
        setDisplayLevel2Form(false)
        setLoading(false)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  return (
    <>
      <CustModal
        open={displayLevel2Form}
        setOpen={setDisplayLevel2Form}
        width="1000px"
        title={t('Admin.EventList.addLevel2')}
        onOk={() => saveLevel2(event)}
      >
        <Spin spinning={loading}>
          <Form form={level2Form}
            initialValues={{ title: event.title, content: stripHtml(event.content) }}>
            <Form.Item name='title' label={t('Admin.EventList.table.level2.title')} rules={[{ required: true }]} >
              <Input />
            </Form.Item>
            <Form.Item name='content' label={t('Admin.EventList.table.level2.content')} rules={[{ required: true }]} >
              <TextArea />
            </Form.Item>
            <Form.Item name='url' label={t('Admin.EventList.table.level2.url')}>
              <Input />
            </Form.Item>
            <Form.Item name='date' label={t('Admin.EventList.table.level2.date')}>
              <DatePicker showTime={{ format: 'HH:mm' }} format="DD/MM/YYYY HH:mm" />
            </Form.Item>
          </Form>
        </Spin>
      </CustModal>
      <Drawer
        title={
          <Form form={form}>
            <Form.Item style={{ marginBottom: '0px' }} name="title">
              <Input style={{ border: 'none', fontWeight: 'bold' }} onBlur={updateTitle} />
            </Form.Item>
          </Form>}
        placement="right"
        closable={true}
        onClose={onClose}
        open={open}
        size={'large'}
        getContainer={false}
        styles={{ root: { height: '87vh' } }}
      >
        <EventDescription event={event} updateEventRequest={updateEventRequest} updateEvent={updateEvent} onClick={onClick} setContent={setContent} saveContent={saveContent}/>
        <Divider />
        <h3>{t('Admin.EventList.table.comments')}</h3>
        <EventComments event={event} comments={comments} addComment={addComment} />
      </Drawer >
    </>
  )
}
